function initDarkMode(darkModeBtn) {
    const darkMode = localStorage.darkMode || 'off';
    //const darkModeToggle = document.querySelector('.js-dark-mode');

    darkModeBtn.addEventListener('click', () => {
        if (localStorage.darkMode === 'off') {
            document.documentElement.classList.add('dark-mode');
            localStorage.darkMode = 'on';
        } else {
            document.documentElement.classList.remove('dark-mode');
            localStorage.darkMode = 'off';
        }
    });
};

export { initDarkMode as default };
